// src/components/Dashboard/EnvioForm.js
import React from 'react';
import {
  TextField,
  Button,
  Typography,
  Box,
  MenuItem,
  CircularProgress,
  Alert
} from '@mui/material';

const TIPOS_VALIDOS = ['Marítimo', 'Aéreo', 'Terrestre'];

export default function EnvioForm({
  formData,
  setFormData,
  onSubmit,
  casilleros = [],
  loadingCreate,
  formValid,
  mensaje
}) {
  const handleChange = (field) => (e) => {
    const value = e.target.value;
    // Mantener el valor tal cual para inputs de texto; para peso permitimos números como string
    setFormData({ ...formData, [field]: value });
  };

  const pesoValido = () => {
    const p = formData?.pesoLibras;
    if (p === null || typeof p === 'undefined' || p === '') return false;
    const n = Number(p);
    return !Number.isNaN(n) && n > 0;
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6">📦 Crear nuevo envío</Typography>

      <TextField
        label="Número de guía"
        fullWidth
        margin="normal"
        required
        value={formData.numeroGuia || ''}
        onChange={handleChange('numeroGuia')}
        error={!String(formData.numeroGuia || '').trim()}
        helperText={!String(formData.numeroGuia || '').trim() ? 'El número de guía es obligatorio' : ''}
      />

      <TextField
        label="Descripción"
        fullWidth
        margin="normal"
        required
        value={formData.descripcion || ''}
        onChange={handleChange('descripcion')}
        error={!String(formData.descripcion || '').trim()}
        helperText={!String(formData.descripcion || '').trim() ? 'La descripción es obligatoria' : ''}
      />

      <TextField
        label="Origen"
        fullWidth
        margin="normal"
        required
        value={formData.origen || ''}
        onChange={handleChange('origen')}
      />

      <TextField
        label="Destino"
        fullWidth
        margin="normal"
        required
        value={formData.destino || ''}
        onChange={handleChange('destino')}
      />

      {/* Campo de peso en libras */}
      <TextField
        label="Peso (libras)"
        type="number"
        fullWidth
        margin="normal"
        required
        value={formData.pesoLibras ?? ''}
        onChange={handleChange('pesoLibras')}
        error={!pesoValido()}
        helperText={!pesoValido() ? 'Debe ingresar el peso en libras (número mayor que 0)' : ''}
        inputProps={{ min: 0, step: '0.01' }}
      />

      {/* Tipo de envío */}
      <TextField
        select
        label="Tipo de envío"
        fullWidth
        margin="normal"
        required
        value={formData.tipoEnvio || ''}
        onChange={handleChange('tipoEnvio')}
      >
        {TIPOS_VALIDOS.map((tipo) => (
          <MenuItem key={tipo} value={tipo}>
            {tipo}
          </MenuItem>
        ))}
      </TextField>

      {/* Casillero (proteger si casilleros es undefined) */}
      <TextField
        select
        label="Casillero"
        fullWidth
        margin="normal"
        required
        value={formData.casilleroCodigo || ''}
        onChange={handleChange('casilleroCodigo')}
      >
        {(casilleros || []).map((c) => {
          const key = c.id || c._id || c.codigo || `${c.codigo}-${Math.random()}`;
          const value = c.codigo || c.id || c._id || '';
          return (
            <MenuItem key={key} value={value}>
              {value} — {c.nombre || c.descripcion || 'Sin descripción'}
            </MenuItem>
          );
        })}
      </TextField>

      {/* Mostrar mensaje de éxito o error */}
      {mensaje && (
        <Alert
          severity={String(mensaje).startsWith('✅') ? 'success' : 'error'}
          sx={{ mt: 2 }}
        >
          {mensaje}
        </Alert>
      )}

      <Button
        variant="contained"
        color="primary"
        onClick={onSubmit}
        disabled={!formValid || loadingCreate}
        sx={{ mt: 2 }}
      >
        {loadingCreate ? <CircularProgress size={24} color="inherit" /> : 'Crear envío'}
      </Button>
    </Box>
  );
}